export const MOCK_OVERVIEW_STATS = {
  codesGenerated: 7,
  activeCodes: 5,
  redemptions: 8,
  redemptionsGrowth: "+18.4%",
  discountGiven: 22725000,
  revenueGenerated: 113570000,
};

export const MOCK_ANALYTICS = {
  attributedGrossRevenue: 64800000,
  currency: "NGN",
  timeframe: "30 Days",
  promoRevenueData: [
    { day: "1", value: 68 },
    { day: "2", value: 60 },
    { day: "3", value: 112 },
    { day: "4", value: 74 },
    { day: "5", value: 68 },
    { day: "6", value: 82 },
    { day: "7", value: 46 },
    { day: "8", value: 62 },
    { day: "9", value: 92 },
    { day: "10", value: 80 },
  ],
  redemptionsData: [
    { day: "1", value: 12 },
    { day: "2", value: 9 },
    { day: "3", value: 24 },
    { day: "4", value: 15 },
    { day: "5", value: 11 },
    { day: "6", value: 18 },
    { day: "7", value: 8 },
    { day: "8", value: 14 },
    { day: "9", value: 21 },
    { day: "10", value: 16 },
  ],
};

export const MOCK_PROMO_CODES = [
  {
    id: "pc-1",
    code: "WEBINAR15",
    discount: "15% off",
    discountType: "percentage",
    discountValue: 15,
    applicablePlans: ["Professional"],
    usage: 78,
    limit: 200,
    validity: "05-09 → 12-09",
    startDate: "2026-09-05",
    endDate: "2026-09-12",
    isExpired: true,
    status: "Expired",
    revenue: 6240000,
    createdBy: {
      name: "Babatunde",
      initials: "BB",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
  {
    id: "pc-2",
    code: "PARTNERPRO",
    discount: "₦100,000 off",
    discountType: "fixed",
    discountValue: 100000,
    applicablePlans: ["Enterprise"],
    usage: 0,
    limit: 50,
    validity: "01-10 → 31-12",
    startDate: "2026-10-01",
    endDate: "2026-12-31",
    isExpired: false,
    status: "Scheduled",
    revenue: null,
    createdBy: {
      name: "Fatima",
      initials: "FS",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
  {
    id: "pc-3",
    code: "EINVOICE100",
    discount: "100% Free Setup",
    discountType: "free_setup",
    discountValue: 100,
    applicablePlans: ["Business", "Enterprise"],
    usage: 30,
    limit: 50,
    validity: "01-09 → 31-12",
    startDate: "2026-09-01",
    endDate: "2026-12-31",
    isExpired: false,
    status: "Active",
    revenue: 24500000,
    createdBy: {
      name: "Fatima",
      initials: "FS",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
  {
    id: "pc-4",
    code: "WELCOME20",
    discount: "20% off",
    discountType: "percentage",
    discountValue: 20,
    applicablePlans: ["All Plans"],
    usage: 124,
    limit: 500,
    validity: "01-09 → 30-09",
    startDate: "2026-09-01",
    endDate: "2026-09-30",
    isExpired: false,
    status: "Active",
    revenue: 10800000,
    createdBy: {
      name: "Adewale",
      initials: "AO",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
  {
    id: "pc-5",
    code: "JUREBSTART",
    discount: "1st Month Free",
    discountType: "first_month_free",
    discountValue: 100,
    applicablePlans: ["Starter", "Professional"],
    usage: 95,
    limit: 100,
    validity: "20-08 → 31-10",
    startDate: "2026-08-20",
    endDate: "2026-10-31",
    isExpired: false,
    status: "Active",
    revenue: 14250000,
    createdBy: {
      name: "Adewale",
      initials: "AO",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
  {
    id: "pc-6",
    code: "SME50",
    discount: "₦50,000 off",
    discountType: "fixed",
    discountValue: 50000,
    applicablePlans: ["Business", "Enterprise"],
    usage: 42,
    limit: 100,
    validity: "15-08 → 15-10",
    startDate: "2026-08-15",
    endDate: "2026-10-15",
    isExpired: false,
    status: "Active",
    revenue: 19600000,
    createdBy: {
      name: "Ngozi",
      initials: "NC",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
  {
    id: "pc-7",
    code: "LAGOSSUMMIT",
    discount: "25% off",
    discountType: "percentage",
    discountValue: 25,
    applicablePlans: ["All Plans"],
    usage: 150,
    limit: 150,
    validity: "10-08 → 25-08",
    startDate: "2026-08-10",
    endDate: "2026-08-25",
    isExpired: false,
    status: "Depleted",
    revenue: 18400000,
    createdBy: {
      name: "Babatunde",
      initials: "BB",
      bgColor: "#F1F5F9",
      textColor: "#475569",
    },
  },
];

export const MOCK_REDEMPTIONS = [
  {
    id: "red-1",
    customerName: "Chinedu Eze",
    companyName: "Dangote Agro Allied Logistics",
    email: "c.eze@dangoteagro.ng",
    promoCode: "SME50",
    planTier: "Business Tier",
    product: "Jureb ERP (annual)",
    platform: "Web",
    original: 1800000,
    discount: 50000,
    finalPaid: 1750000,
    dateRedeemed: "2026-09-08 09:14 WAT",
    status: "active",
  },
  {
    id: "red-2",
    customerName: "Amina Bello",
    companyName: "FCT Fast Moving Consumer Goods",
    email: "amina@fctfmcg.com",
    promoCode: "WELCOME20",
    planTier: "Professional Tier",
    product: "Jureb Accounting (annual)",
    platform: "iOS",
    original: 780000,
    discount: 100000,
    finalPaid: 680000,
    dateRedeemed: "2026-09-07 16:42 WAT",
    status: "active",
  },
  {
    id: "red-3",
    customerName: "Oluwaseun Bakare",
    companyName: "Bakare Haulage & Warehousing Ltd",
    email: "info@bakarehaulage.com",
    promoCode: "EINVOICE100",
    planTier: "Enterprise Tier",
    product: "Jureb E-Invoicing (annual)",
    platform: "Android",
    original: 4560000,
    discount: 150000,
    finalPaid: 4410000,
    dateRedeemed: "2026-09-06 14:10 WAT",
    status: "active",
  },
  {
    id: "red-4",
    customerName: "Emeka Nwosu",
    companyName: "Rivers Offshore & Marine Equipment",
    email: "e.nwosu@riversmarine.com",
    promoCode: "RESELLER30",
    planTier: "Business Tier",
    product: "Jureb Payroll (annual)",
    platform: "Web",
    original: 1800000,
    discount: 150000,
    finalPaid: 1650000,
    dateRedeemed: "2026-09-05 11:30 WAT",
    status: "active",
  },
  {
    id: "red-5",
    customerName: "Bisi Adeleke",
    companyName: "Adeleke Advisory & Audit LLP",
    email: "bisi@adelekefinance.ng",
    promoCode: "WELCOME20",
    planTier: "Starter Tier",
    product: "Jureb Accounting (monthly)",
    platform: "iOS",
    original: 25000,
    discount: 5000,
    finalPaid: 20000,
    dateRedeemed: "2026-09-04 18:22 WAT",
    status: "trial",
  },
  {
    id: "red-6",
    customerName: "Kabiru Sanusi",
    companyName: "Kano Commercial Textiles Ltd",
    email: "k.sanusi@kanotextiles.ng",
    promoCode: "SME50",
    planTier: "Business Tier",
    product: "Jureb ERP (annual)",
    platform: "Android",
    original: 1800000,
    discount: 50000,
    finalPaid: 1750000,
    dateRedeemed: "2026-09-03 10:05 WAT",
    status: "active",
  },
  {
    id: "red-7",
    customerName: "Folashade Alabi",
    companyName: "Apex Logistics & Haulage",
    email: "f.alabi@apexlogistics.ng",
    promoCode: "JUREBSTART",
    planTier: "Starter Tier",
    product: "Jureb HR (annual)",
    platform: "Web",
    original: 150000,
    discount: 30000,
    finalPaid: 120000,
    dateRedeemed: "2026-09-02 13:40 WAT",
    status: "active",
  },
];
